import { createContext, useContext, useState } from 'react';
import type { IEditablePageWrapperContextProvider, IEditablePageWrapperContext } from './IEditablePageContext';
import type { IBookingURLParams, INonEditableField } from '@echotex/api-merchandising';

const DummyMethod = () => {};

const dummyBookingData = {
  isOrderWise: false,
  orderTypeId: 0,
  orderTypeName: '',
  orderBookingNameId: 0,
  orderBookingName: '',
  businessDynamicId: 0,
  businessDynamicName: '',
};

const EditablePageWrapperContext = createContext<IEditablePageWrapperContext>({
  pageContentDetail: null,
  setPageContentDetails: DummyMethod,

  bookingData: dummyBookingData,
  setBookingData: DummyMethod,

  orderBookingData: null,
  setOrderBookingData: DummyMethod,

  bomData: null,
  setBomData: DummyMethod,

  fieldConfigurations: null,
  setFieldConfigurations: DummyMethod,
});
EditablePageWrapperContext.displayName = 'EditablePageWrapperContext';

// The hook to expose the context value
export const useEditablePageContext = () => {
  return useContext(EditablePageWrapperContext);
};

// The context provider
export const EditablePageWrapperContextProvider = ({ children }: IEditablePageWrapperContextProvider): JSX.Element => {
  const [pageContentDetail, setPageContentDetails] = useState<any>(null);
  const [bookingData, setBookingData] = useState<IBookingURLParams>(dummyBookingData);
  const [orderBookingData, setOrderBookingData] = useState<any>(null);
  const [bomData, setBomData] = useState<any>(null);
  const [fieldConfigurations, setFieldConfigurations] = useState<INonEditableField | null>(null);

  return (
    <EditablePageWrapperContext.Provider
      value={{
        pageContentDetail,
        setPageContentDetails,
        bookingData,
        setBookingData,
        orderBookingData,
        setOrderBookingData,
        bomData,
        setBomData,
        fieldConfigurations,
        setFieldConfigurations,
      }}>
      {children}
    </EditablePageWrapperContext.Provider>
  );
};
